type Props = {
    className?: string;
};

export default function SpinLoading({ className }: Props) {
    return (
        <div
            className={`border border-2px border-t-black border-white bg-transparent animate-spin w-6 h-6 rounded-full ${className} `}
        />
    );
}
